import React from 'react';

import { Track, TrackFunc, TrackingData } from '@justgiving/react-tracking';
import { captureException } from '@sentry/browser';

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T, K> = Omit<T, keyof K>;

interface Analytics {
  track: TrackFunc;
}

const analytics: Analytics = {
  track: (trackingData: TrackingData) => {
    try {
      if (window && window.dataLayer) {
        window.dataLayer.push(trackingData);
      }
    } catch (error) {
      captureException(error);
    }
  },
};

export interface WithTrack {
  track: (data: TrackingData) => void;
}

export const withTrack = <P extends WithTrack>(
  WrappedComponent: React.ComponentType<P>,
) =>
  function Component(props: Subtract<P, WithTrack>) {
    return (
      <Track>
        {track => <WrappedComponent {...(props as P)} track={track} />}
      </Track>
    );
  };

export default analytics;
